import { Navigate, useOutletContext, useParams } from 'react-router-dom'

import { TrainingMembershipFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { FileViewer } from 'modules/trainings/components/Files/FileViewer'
import { useTrainingsMixedFiles } from 'modules/trainings/hooks/Files/useMixedFiles'
import { useSessionFilesContext } from 'modules/trainings/hooks/SessionFiles/useSessionFilesContext'
import { useTrainingFilesContext } from 'modules/trainings/hooks/TrainingFiles/useTrainingFilesContext'

const EmployeeFileViewer = () => {
  const { id, trainingId, trainingFileId } = useParams()
  const { navigation } = useNavigation()
  const { trainingFiles } = useTrainingFilesContext()
  const { sessionFiles } = useSessionFilesContext()
  const { buildFilesList } = useTrainingsMixedFiles()
  const { trainingMemberships, employeeAccessId } = useOutletContext<{
    trainingMemberships: TrainingMembershipFragment[]
    employeeAccessId: number
  }>()
  const trainingMembership = trainingMemberships.find(
    (membership) =>
      membership.trainingId === Number(trainingId) && membership.accessId === employeeAccessId
  )

  const files = buildFilesList({
    trainingFiles,
    sessionFiles,
    membershipFiles: trainingMembership?.trainingMembershipFiles,
  }).map((f) => ({
    ...f,
    fileUrl: f.url,
    title: f.title || f.filename,
  }))

  const file = files.find((_file) => _file.id === Number(trainingFileId))

  const back = navigation.employees.id.training.detail.view.fullPath({
    id: String(id),
    trainingId: String(trainingId),
  })

  if (!file) return <Navigate replace to={back} />

  return (
    <>
      <FileViewer
        files={files}
        file={file}
        urlBackTo={back}
        goNextFile={(trainingsFile) =>
          navigation.employees.id.training.detail.view.fileViewer.fullPath({
            id: String(id),
            trainingId: String(trainingId),
            trainingFileId: trainingsFile.fileUrl,
          })
        }
        goPrevFile={(trainingsFile) =>
          navigation.employees.id.training.detail.view.fileViewer.fullPath({
            id: String(id),
            trainingId: String(trainingId),
            trainingFileId: trainingsFile.fileUrl,
          })
        }
      />
    </>
  )
}

export default EmployeeFileViewer
